import { Component, OnInit, Output, EventEmitter, OnDestroy, Input } from '@angular/core';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { RouteService } from '../service/route.service';
import { DriversService } from 'src/app/component/drivers/drivers-service/drivers-service';
import { FleetService } from 'src/app/component/fleet/fleet-service/fleet.service';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-route-details-modal',
  templateUrl: './route-details-modal.component.html',
  styleUrls: ['./route-details-modal.component.css']
})
export class RouteDetailsModalComponent implements OnInit, OnDestroy {
  @Input() id: string;
  @Output() close = new EventEmitter<void>();

  route: any;
  loading = true;
  user: any;
  timeZone: string;
  driver: any = null;
  fleet: any = null;

  constructor(
    private routeService: RouteService,
    private sharedDataService: SharedDataService,
    private driverService: DriversService,
    private fleetService: FleetService
  ) { }

  ngOnInit() {
    this.getUser();
  }

  ngOnDestroy() { }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.timeZone = this.user.timeZone || 'America/Chicago';
          if (this.id) {
            this.getRouteDetails();
          }
        }
      });
  }

  loadMetadata() {
    // Load drivers for mapping names/images
    this.driverService.getDriversByID(this.route.driver)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(driver => {
        this.driver = driver;
        if (this.driver && this.driver.fleet && this.driver.fleet._id) {
          this.fleetService.getFleetDataById(this.driver.fleet._id)
            .pipe(takeUntil(componentDestroyed(this)))
            .subscribe(fleet => {
              this.fleet = fleet;
            });
        }
      });

  }

  getRouteDetails() {
    this.loading = true;
    this.routeService.getRoutesbyId(this.id)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          this.route = data;
          this.loadMetadata();
          this.loading = false;
        },
        (err) => {
          console.error('Error fetching route details', err);
          this.loading = false;
        }
      );
  }

  onClose() {
    this.close.emit();
  }

  formatDate(date: string): string {
    if (!date) return 'N/A';
    return moment(date).tz(this.timeZone).format('MMM DD, YYYY');
  }

  formatTime(date: string): string {
    if (!date) return 'N/A';
    return moment(date).tz(this.timeZone).format('hh:mm A');
  }

  getStatusClass(status: string): string {
    const s = status ? status.toLowerCase() : '';
    switch (s) {
      case 'completed': return 'bg-emerald-50 text-emerald-700 ring-emerald-600/20';
      case 'inprogress': return 'bg-indigo-50 text-indigo-700 ring-indigo-600/20';
      case 'scheduled': return 'bg-slate-100 text-slate-700 ring-slate-500/20';
      case 'cancelled': return 'bg-rose-50 text-rose-700 ring-rose-600/20';
      default: return 'bg-slate-50 text-slate-600 ring-slate-500/10';
    }
  }

  getStopStatusClass(status: string): string {
    const s = status ? status.toLowerCase() : '';
    switch (s) {
      case 'departed':
      case 'completed': return 'text-emerald-600 bg-emerald-50';
      case 'arrived': return 'text-sky-600 bg-sky-50';
      case 'skipped': return 'text-rose-600 bg-rose-50';
      default: return 'text-slate-400 bg-slate-50';
    }
  }


  trackById(index: number, item: any): string {
    return item._id || item.id || index;
  }
}
